import { render } from "./Academic-Excellence.vue?vue&type=template&id=e9e8e7ba"
import script from "./Academic-Excellence.vue?vue&type=script&lang=js"
export * from "./Academic-Excellence.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3279127340/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__